export default __webpack_public_path__ + "static/media/0_en.3a6ec663.png";